<section
  class="bg-[url('/images/footer/footer-bg.webp')] bg-cover bg-top bg-no-repeat"
  *transloco="let t"
>
  <section class="cta-section">
    <div
      class="container px-4 py-16 sm:py-20 md:py-28 flex flex-col items-center text-center"
    >
      <h2 hlmH1>
        {{ t('footer.cta.title') }}
      </h2>
      <p hlmP class="max-w-xl mb-8">
        {{ t('footer.cta.description') }}
      </p>
      <button
        hlmBtn
        variant="default"
        size="lg"
        data-cal-link="juan-manuel-ortiz-gz54cr/30min"
        data-cal-namespace="30min"
        data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true","theme":"light"}'
      >
        {{ t('footer.cta.bookADemo') }}
        <ng-icon hlm name="lucideArrowRight" size="sm" />
      </button>
    </div>
  </section>

  <footer class="footer-section">
    <div class="container pb-10 sm:pb-14 px-4">
      <div class="flex flex-col lg:flex-row gap-4 sm:gap-6">
        <div
          class="rounded-2xl p-4 md:p-6 flex flex-col bg-[url('/images/footer/card-bg.webp')] bg-cover bg-center bg-no-repeat min-h-[200px] sm:min-h-[240px] lg:min-w-[380px] lg:min-h-0"
        >
          <img
            src="/images/logo.webp"
            alt="GuestGenie"
            class="invert max-w-40 sm:max-w-48 md:max-w-56"
          />

          <div class="mt-auto pt-8 sm:pt-12 md:pt-16">
            <h3 hlmH6 class="text-neutral-400">{{ t('footer.getInTouch') }}</h3>
            <a
              href="mailto:support@guestgenie.com"
              class="text-white font-semibold text-sm mt-1 block"
            >
              <span hlmH6 class="text-primary-300"
                >support&#64;guestgenie.com</span
              >
            </a>

            <div class="flex gap-3 mt-5">
              <a
                href="https://www.linkedin.com/company/guestgenie/"
                target="_blank"
                rel="noopener noreferrer"
                hlmBtn
                class="bg-white hover:bg-white/80 active:bg-white/90 border-0"
                size="icon"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/guestgenieapp"
                target="_blank"
                rel="noopener noreferrer"
                hlmBtn
                size="icon"
                class="bg-white hover:bg-white/80 active:bg-white/90 border-0"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <circle cx="12" cy="12" r="5" />
                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1.5"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col justify-between flex-1 gap-6 sm:gap-4 rounded-2xl p-4 md:p-6 bg-white min-w-0"
        >
          <div class="flex flex-col sm:flex-row gap-8 sm:gap-12 lg:gap-16">
            <div class="flex flex-1 flex-col gap-5">
              <span hlmPretitle>{{ t('footer.solutions') }}</span>
              <nav class="flex flex-col gap-3">
                <a
                  [routerLink]="['/', activeLang, 'platform', 'for-guests']"
                  class="group"
                >
                  <p
                    hlmP
                    class="text-gray-800 font-semibold group-hover:text-black transition-colors"
                  >
                    {{ t('footer.forGuests') }}
                  </p>
                </a>
                <a
                  [routerLink]="[
                    '/',
                    activeLang,
                    'platform',
                    'for-service-providers',
                  ]"
                  class="group"
                >
                  <p
                    hlmP
                    class="text-gray-800 font-semibold group-hover:text-black transition-colors"
                  >
                    {{ t('footer.forServiceProviders') }}
                  </p>
                </a>
                <a
                  [routerLink]="[
                    '/',
                    activeLang,
                    'platform',
                    'overview',
                  ]"
                  class="group"
                >
                  <p
                    hlmP
                    class="text-gray-800 font-semibold group-hover:text-black transition-colors"
                  >
                    {{ t('footer.forPropertyOperators') }}
                  </p>
                </a>
              </nav>
            </div>

            <div class="flex flex-1 flex-col gap-5">
              <span hlmPretitle>{{ t('footer.company') }}</span>
              <nav class="flex flex-col gap-3">
                <a
                  [routerLink]="['/', activeLang, 'about-us']"
                  class="group"
                >
                  <p
                    hlmP
                    class="text-gray-800 font-semibold group-hover:text-black transition-colors"
                  >
                    {{ t('footer.aboutUs') }}
                  </p>
                </a>
                <a class="group" [routerLink]="['/', activeLang, 'become-a-partner']">
                  <p
                    hlmP
                    class="text-gray-800 font-semibold group-hover:text-black transition-colors"
                  >
                    {{ t('footer.becomeAPartner') }}
                  </p>
                </a>
              </nav>
            </div>
          </div>

          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
          >
            <div class="flex items-center flex-wrap gap-x-4 gap-y-1">
              <p hlmSmall class="text-muted-foreground">
                &copy; {{ currentYear }} {{ t('footer.copyright') }}
              </p>
              <span class="text-primary-300">&bull;</span>
              <button
                type="button"
                class="text-gray-800 hover:text-black transition-colors cursor-pointer bg-transparent border-0 p-0 font-inherit"
                (click)="openPolicyDialog(termsUrl)"
              >
                <p hlmSmall class="font-semibold">{{ t('footer.terms') }}</p>
              </button>
              <span class="text-primary-300">&bull;</span>
              <button
                type="button"
                class="text-gray-800 hover:text-black transition-colors cursor-pointer bg-transparent border-0 p-0 font-inherit"
                (click)="openPolicyDialog(privacyPolicyUrl)"
              >
                <p hlmSmall class="font-semibold">{{ t('footer.privacy') }}</p>
              </button>
            </div>

            <div class="flex items-center">
              <brn-select
                hlm
                [ngModel]="activeLang"
                (ngModelChange)="switchLanguage($event)"
                role="listbox"
                [attr.aria-label]="t('footer.language')"
                class="inline-block w-fit"
              >
                <hlm-select-trigger
                  class="w-20 bg-secondary-50 border-secondary-100"
                >
                  {{ activeLang | uppercase }}
                </hlm-select-trigger>
                <hlm-select-content>
                  @for (lang of languages; track lang) {
                    <hlm-option [value]="lang">{{
                      t('lang.' + lang)
                    }}</hlm-option>
                  }
                </hlm-select-content>
              </brn-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</section>
